import React from 'react';
import { Box } from '@mui/material'
import { HeroSection } from '../components/LandingPages/DoutorMonitora/HeroSection'
import { PricingSection } from '../components/LandingPages/DoutorMonitora/PricingSection'
import { HowItWorksSection } from '../components/LandingPages/DoutorMonitora/HowItWorksSection'
import { BenefitsSection } from '../components/LandingPages/DoutorMonitora/BenefitsSection'
import { HeaderDrMonitora } from '../components/LandingPages/DoutorMonitora/Header'
import Footer from '../components/Footer';
import './Planos.scss';

export const DoutorMonitoraLP = (): React.JSX.Element => {
  return (
    <Box sx={{ minHeight: '100vh', background: '#FFFFFF', color: '#1a202c' }}>
      <HeaderDrMonitora />
      <main>
        <HeroSection />
        <PricingSection />
        <HowItWorksSection />
        <BenefitsSection />
      </main>
      <Footer />
    </Box>
  );
};
